import { createApp } from 'vue'
import router from './router'
import { createPinia } from "pinia";
import App from './App.vue'

import "@/assets/tailwind.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faAnglesLeft,
  faAnglesRight,
  faChevronLeft,
  faChevronRight,
  faListOl,
  faMoon,
  faSun,
  faTruckMoving,
} from "@fortawesome/free-solid-svg-icons";
import Toaster from "@meforma/vue-toaster"

library.add(
  faListOl,
  faTruckMoving,
  faAnglesLeft,
  faChevronLeft,
  faChevronRight,
  faAnglesRight,
  faMoon,
  faSun
);

const app = createApp(App)
app.config.globalProperties.appName = 'hsctco-app'
app.config.globalProperties.appEnv = 'prod' // prod or devel
app.config.globalProperties.apiHost = process.env.VUE_APP_API_HOST
const pinia = createPinia();

app.use(router)
  .use(pinia)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(Toaster, {
    position: "bottom",
    dismissible: true,
    maxToasts: 5
  })
  .mount('#app')
